export enum LoginFlowStep {
  EnterEmail,
  EnterPasswordAndConnect,
  EnterPasswordAndSignIn,
  EnterPasswordAndSignUp,
  EmailVerification,
  ForgottenPassword,
  ForgottenPasswordMessage,
  EmailAlreadySentErrorMessage,
  EnterNewPassword,
  EnterNewPasswordMessage,
  EmailChange,
}
